import React, { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import { FreeSpinMode, Rule, Symbols } from "./type";
import GameUtils from "./utils";
import Utils from "../../utils";

export const DearSenpaiRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const {
    payouts = {},
    buyFreeSpinRate = 50,
    givenFreeSpin = {},
  } = data as Rule;
  return (
    <>
      <h5 className="card-title">What it is</h5>
      <p className="ps-3 card-text">
        Dear, Senpai is a 3-reel, 3-row video slot featuring respins and 3x to
        20x multipliers.
      </p>
      <h5>How it's played</h5>
      <p className="ps-3 card-text">
        The game is played with 5 bet lines (fixed)
      </p>
      <p className="ps-3 card-text">
        Winning combinations and payouts are made according to the "Paytable".
      </p>
      <p className="ps-3 card-text">
        A bet line win in cash is equal to the value shown in the "Paytable"
        multiplied by the bet size.
      </p>
      <p className="ps-3 card-text">
        {" "}
        Only the highest win per bet line is paid.
      </p>
      <p className="ps-3 card-text">
        Bet lines win if the winning symbols are in succession from the left
        most reel to right.
      </p>

      <h5 className="card-title">Bonus Features</h5>

      <h6 className="ps-3">
        Scatter Symbol
        <div className="symbol d-inline-block">
          {GameUtils.convertSymbol(Symbols.Scatter, FreeSpinMode.None)}
        </div>
      </h6>
      <p className="ps-3 card-text">
        Scatter Symbols are special Symbols that will appear at random
        throughout the game.
      </p>
      <p className="ps-3 card-text">
        If 3 scatter symbols appear throughout the reels. Players will be
        rewarded 12 Free Spins.
      </p>

      <h6 className="ps-3">
        Wild Symbol
        <div className="symbol d-inline-block">
          {GameUtils.convertSymbol(Symbols.Wild, FreeSpinMode.None)}
        </div>
        <div className="symbol d-inline-block">
          {GameUtils.convertSymbol(Symbols.Wild, FreeSpinMode.Male)}
        </div>
        <div className="symbol d-inline-block">
          {GameUtils.convertSymbol(Symbols.Wild, FreeSpinMode.Female)}
        </div>
      </h6>
      <p className="ps-3 card-text">
        Wild symbol replaces all symbols except scatter symbol.
      </p>

      <h6 className="ps-3">Stacked Wild Symbol</h6>
      <div className="ps-3">
        <div className="symbol stacked d-inline-block">
          {GameUtils.getStackWild(FreeSpinMode.None)}
        </div>
        <div className="symbol stacked d-inline-block">
          {GameUtils.getStackWild(FreeSpinMode.Male)}
        </div>
        <div className="symbol stacked d-inline-block">
          {GameUtils.getStackWild(FreeSpinMode.Female)}
        </div>
      </div>
      <p className="ps-3 card-text">
        During any Main Game spin, 3 Wild Symbols in a reel will be transformed
        into Stacked Wild Symbols.
      </p>
      <p className="ps-3 card-text">
        During any Main Game spin, when 1 or more Stacked Wild Symbols appear in
        any reel, all wins in the spin will be multiplied by 2x before the wins
        are paid.
      </p>

      <h6 className="ps-6">Free Spin</h6>

      <p className="ps-3 card-text">
        During the Free Spins Feature, the Stacked Wild symbol will appear fully
        on reel 2, and the other reels will respin for x amount of time
        depending on chosen modes.
      </p>
      <p className="ps-3 card-text">
        The win from the Free Spins feature will be multiplied by a multiplier
        ranging from x3 to x11 or x12 to x20 (depending which game mode they
        chose) before wins are paid.
      </p>
      <p className="ps-3 card-text">
        After a payout line is matched the reels will stop spinning and the
        payout amount will be multiplied by the wild multiplier in reel 2 based
        on the paytable. Winning paylines are paid out to the player.
      </p>

      <h5 className="card-title">Paytable</h5>

      <h6 className="ps-3">Symbol Payout Values</h6>
      <p className="ps-3 d-flex flex-wrap">
        <div className="col-3 text-center">
          <div className="d-flex justify-content-center">
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Wild, FreeSpinMode.None)}
            </div>
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Wild, FreeSpinMode.Female)}
            </div>
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Wild, FreeSpinMode.Male)}
            </div>
          </div>
          x100
        </div>
        <div className="col-3 text-center">
          <div className="d-flex justify-content-center">
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol1, FreeSpinMode.Female)}
            </div>
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol1, FreeSpinMode.Male)}
            </div>
          </div>
          x50
        </div>
        <div className="col-3 text-center">
          <div className="d-flex justify-content-center">
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol2, FreeSpinMode.Female)}
            </div>
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol2, FreeSpinMode.Male)}
            </div>
          </div>
          x25
        </div>
        <div className="col-3 text-center">
          <div className="d-flex justify-content-center">
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol3, FreeSpinMode.Female)}
            </div>
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol3, FreeSpinMode.Male)}
            </div>
          </div>
          x15
        </div>
      </p>
      <p className="ps-3 d-flex flex-wrap">
        <div className="col-3 text-center">
          <div className="d-flex justify-content-center">
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol4, FreeSpinMode.Female)}
            </div>
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol4, FreeSpinMode.Male)}
            </div>
          </div>
          x10
        </div>
        <div className="col-3 text-center">
          <div className="d-flex justify-content-center">
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol5, FreeSpinMode.None)}
            </div>
          </div>
          x5
        </div>
        <div className="col-3 text-center">
          <div className="d-flex justify-content-center">
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol6, FreeSpinMode.Female)}
            </div>
          </div>
          x3
        </div>
        <div className="col-3 text-center">
          <div className="d-flex justify-content-center">
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol7, FreeSpinMode.Female)}
            </div>
            <div className="symbol mr-1">
              {GameUtils.convertSymbol(Symbols.Symbol7, FreeSpinMode.Male)}
            </div>
          </div>
          x2
        </div>
      </p>
      <h6 className="ps-3">Winning Bet Lines</h6>
      <p className="ps-3 d-flex flex-wrap justify-content-center">
        {Array.from({ length: 5 }, (_, i) => i + 1).map((line) => (
          <div key={`line-${line}`} className="col-2 text-center">
            {Utils.drawLine(3, GameUtils.takePayline(line))}
            <span>Line {line}</span>
          </div>
        ))}
      </p>
    </>
  );
};
